// AI-CONTEXT: See docs/features/subscriptions-overview-page.md
//
// De koepelregel onder een organisatienaam in het abonnementenoverzicht.
//
// Drie toestanden, en ze zijn niet inwisselbaar. "geen koepel" is een bewering
// aan de lezer: die mag alleen op het scherm als we weten dat er geen koepel is.
// Een koepel-id waar geen CompagnyMeta-document bij hoort (24 van de 73) is iets
// anders — daar is wél een koepel, alleen kennen we zijn naam niet.
// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading

/**
 * @typedef {object} KoepelVelden
 * @property {Array<string>} [parents] - namen van de koepels, voor zover op te zoeken
 * @property {number} [parentCount] - hoeveel koepels er zijn; kan hoger zijn dan parents.length
 */

/**
 * @param {KoepelVelden} [row] - rij uit getSubscriptionsOverview
 * @returns {string} regel om onder de organisatienaam te zetten
 */
const parentLabel = (row) => {
    const parents = Array.isArray(row && row.parents) ? row.parents.filter(Boolean) : []
    if (parents.length) return parents.join(', ')

    // Alleen een écht getelde nul rechtvaardigt "geen koepel". Ontbreekt het
    // veld, dan weten we het niet — en dan zeggen we dat.
    const count = row && row.parentCount
    return count === 0 ? 'geen koepel' : 'koepel onbekend'
}

export default parentLabel
